export default __webpack_public_path__ + "static/media/ripenready.9beb75d6.jpg";